import React from 'react'

import { Form, Table } from '_zari/core'

import * as Modals from './modals'

const FilaDetalleTemplate = ({ index, row, actualizarFilaHandler, eliminarFilaHandler, afectacionesCompra }) => {
  const [mostrarModalHistorialCompras, setMostrarModalHistorialCompras] = React.useState(false)
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [subTotal, setSubTotal] = React.useState(row.subTotal)
  const [flete, setFlete] = React.useState(row.flete)
  const [isc, setIsc] = React.useState(row.isc)

  const bloqueado = !!row._fromOrdenCompra

  // Sincronizar inputs con row cuando el reducer recalcula (ej. al cambiar cantidad en fila OC,
  // el subTotal se recalcula y debe verse en el input).
  React.useEffect(() => {
    setSubTotal(row.subTotal)
  }, [row.subTotal])
  React.useEffect(() => {
    setCantidad(row.cantidad)
  }, [row.cantidad])

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode
    let __focusCantidad = true
    let __focusPrecio = false
    let __focusSubTotal = false
    let __focusIsc = false
    let __focusFlete = false
    let saltarFila = false
    let saltarCampo = false

    // El reducer decide si limpiar subTotal (fila manual) o recalcularlo (fila OC con precio).
    // El useEffect sincroniza el input con row.subTotal cuando el reducer cambia el valor.

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
      __focusCantidad = false
      __focusSubTotal = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      subTotal,
      isc,
      flete,
      __updatedField: 'cantidad',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const onChangeAfectacionHandler = e => {
    const value = e.target.value
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusSubTotal = false
    let __focusIsc = false
    let __focusFlete = false
    let saltarFila = false
    let saltarCampo = true

    actualizarFilaHandler({
      ...row,
      afectacion: value,
      cantidad,
      subTotal,
      isc,
      flete,
      __updatedField: 'subtotal',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyUpSubTotalHandler = e => {
    const keyCode = e.keyCode
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusSubTotal = true
    let __focusIsc = false
    let __focusFlete = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
      __focusSubTotal = false
      saltarCampo = true
      saltarFila = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      subTotal,
      isc,
      flete,
      __updatedField: 'subtotal',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownSubTotalHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpIscHandler = e => {
    const keyCode = e.keyCode
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusSubTotal = false
    let __focusIsc = true
    let __focusFlete = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
      __focusIsc = false
      __focusFlete = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      subTotal,
      isc,
      flete,
      __updatedField: 'isc',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownIscHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpFleteHandler = e => {
    const keyCode = e.keyCode
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusSubTotal = false
    let __focusIsc = false
    let __focusFlete = true
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
      __focusFlete = false
      saltarCampo = true
      saltarFila = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      subTotal,
      isc,
      flete,
      __updatedField: 'flete',
      __focusCantidad,
      __focusPrecio,
      __focusSubTotal,
      __focusIsc,
      __focusFlete,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownFleteHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad && cantidad === '') {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad, cantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td className='text-center'>{row.codigoProducto || '--'}</td>
        <td>{row.nombreProducto || '--'}</td>
        <td>
          <Form.InputNumber
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td className='text-center'>{row.nombreUnidadDeMedida || row.unidadMedida || '--'}</td>
        <td>
          <Form.Select value={row.afectacion} onChange={onChangeAfectacionHandler}>
            {afectacionesCompra.map((x, k) => (
              <option key={k} value={x._id}>
                {x.nombre}
              </option>
            ))}
          </Form.Select>
        </td>
        <td className='text-center'>{row.precio || '--'}</td>
        <td>
          <Form.InputText
            placeholder='0'
            value={subTotal}
            onChange={e => setSubTotal(e.target.value)}
            onKeyUp={keyUpSubTotalHandler}
            onKeyDown={keyDownSubTotalHandler}
            onFocus={e => e.currentTarget.select()}
            autoFocus={row.__filaActiva && row.__focusSubTotal}
            disabled={bloqueado}
          />
        </td>
        <td>
          <Form.InputText
            placeholder='0'
            value={isc}
            onChange={e => setIsc(e.target.value)}
            onKeyUp={keyUpIscHandler}
            onKeyDown={keyDownIscHandler}
            onFocus={e => e.currentTarget.select()}
            autoFocus={row.__filaActiva && row.__focusIsc}
            disabled={bloqueado}
          />
        </td>
        <td>
          <Form.InputText
            placeholder='0'
            value={flete}
            onChange={e => setFlete(e.target.value)}
            onKeyUp={keyUpFleteHandler}
            onKeyDown={keyDownFleteHandler}
            onFocus={e => e.currentTarget.select()}
            autoFocus={row.__filaActiva && row.__focusFlete}
            disabled={bloqueado}
          />
        </td>
        <td>{row.total || '0.00'}</td>
        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='historial-compras'
                handleClose={handleClose}
                onClick={w => setMostrarModalHistorialCompras(true)}
              >
                Ver Compras
              </Table.Dropdown.Item>,
              !bloqueado && (
                <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                  Eliminar
                </Table.Dropdown.Item>
              )
            ]}
          </Table.Dropdown>
        </td>
      </tr>
      {mostrarModalHistorialCompras && (
        <Modals.HistorialComprasModal
          handleClose={e => setMostrarModalHistorialCompras(false)}
          show={mostrarModalHistorialCompras}
          idProductoPresentacion={row._idProductoPresentacion}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
